import { BANKING_CHARGE_STATUS } from '../banking-charge';
import { DjangoBankingCharge, parseBankingCharge } from '../banking-charge/banking-charge.model';
import { parseNumeric } from '../helpers/number';
import { BankingCharge } from './../banking-charge/banking-charge.model';
import { applyTimezone, parseDate } from './../helpers/date';
import { INVOICE_PAYABLE_STATUSES, INVOICE_STATUS } from './invoice-status.model';

export class Invoice {
  id: string;
  balance: number;
  created: Date;
  modified: Date;
  closingDate: Date;
  dueDate: Date;
  amount: number;
  currency: string;
  status: INVOICE_STATUS;
  bankingCharge: BankingCharge;

  constructor(data: string | Invoice | DjangoInvoice = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }

  get canRegisterPayment() {
    return canRegisterPayment(this);
  }

  get canGenerateNewBankingCharge() {
    return canGenerateNewBankingCharge(this);
  }

  get canCancelBankingCharge() {
    return canCancelBankingCharge(this);
  }
}

export function parseInvoice(val) {
  if (val) {
    return new Invoice(val);
  } else {
    return undefined;
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////
export interface DjangoInvoice {
  id?: string;
  balance?: string;
  created?: string;
  due_date?: string;
  modified?: Date;
  closing_date?: string;
  amount?: string;
  currency?: string;
  status?: INVOICE_STATUS;
  banking_charge?: string | DjangoBankingCharge;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(instance: Invoice, data: Invoice | DjangoInvoice) {
  const jsData = bindDjangoPropsToJs(data);
  instance.id = jsData.id;
  instance.balance = parseNumeric(jsData.balance);
  instance.created = parseDate(jsData.created);
  instance.modified = parseDate(jsData.modified);
  instance.closingDate = applyTimezone(parseDate(jsData.closingDate), 0);
  instance.dueDate = applyTimezone(parseDate(jsData.dueDate), 0);
  instance.amount = parseNumeric(jsData.amount);
  instance.currency = jsData.currency;
  instance.status = jsData.status;
  instance.bankingCharge = parseBankingCharge(jsData.bankingCharge);
}

function bindDjangoPropsToJs(data: Invoice | DjangoInvoice) {
  const djangoData = data as DjangoInvoice;
  const jsData = data as Invoice;
  return {
    ...data,
    dueDate: djangoData.due_date || jsData.dueDate,
    closingDate: djangoData.closing_date || jsData.closingDate,
    bankingCharge: djangoData.banking_charge || jsData.bankingCharge,
  } as Invoice;
}

///////////////
/// HELPERS ///
///////////////
function canRegisterPayment(instance: Invoice): boolean {
  return INVOICE_PAYABLE_STATUSES.includes(instance.status);
}

function canGenerateNewBankingCharge(instance: Invoice): boolean {
  return (
    !instance.bankingCharge || instance.bankingCharge.status === BANKING_CHARGE_STATUS.CANCELED
  );
}

function canCancelBankingCharge(instance: Invoice): boolean {
  return (
    !!instance.bankingCharge &&
    ![BANKING_CHARGE_STATUS.CANCELED, BANKING_CHARGE_STATUS.RECEIVED].includes(
      instance.bankingCharge.status,
    )
  );
}
